import { collection, query, where, getDocs } from 'firebase/firestore'
import { fs, fbStorage } from './firebase'

export function getCategories() {
  return new Promise((resolve, reject) => {
    fs.collection('categories')
      .get()
      .then(querySnapshot => {
        let categories = [];
        querySnapshot.forEach(doc => {
          categories.push(doc.data())
        })
        resolve(categories);
      })

  })
}
